import { render } from "./HomeBenefits.vue?vue&type=template&id=2a80ca04&scoped=true"
import script from "./HomeBenefits.vue?vue&type=script&lang=js"
export * from "./HomeBenefits.vue?vue&type=script&lang=js"

import "./HomeBenefits.vue?vue&type=style&index=0&id=2a80ca04&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a80ca04"]])

export default __exports__